/*
 * *****************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Wed, Jul 21st 2021, 8:32:08 am
 *
 * *****************************************************
 */

import styled from 'styled-components';

import { ReactComponent as Google } from 'assets/images/google.svg';

export const Container = styled.div`
  width: 100%;

  /* OVERRIDEN CSS */
  Polaris-Button {
    width: 100%;
  }
  .Polaris-Button__Icon {
    display: flex;
  }
  .Polaris-Button__Icon + *:not(.Polaris-Button__Icon) {
    margin-left: 1.2rem;
  }
`;

export const GoogleIcon = styled(Google)`
  width: 1.6rem;
  height: 1.6rem;
`;
